import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const t = auth.getToken();
  if (t) {
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${t}` },
    });
  }
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 403 && err.error?.email_nao_verificado) {
        const url = router.url.split('?')[0];
        if (!url.startsWith('/auth/signup') && !url.startsWith('/auth/verify-email')) {
          void router.navigate(['/auth/signup']);
        }
        return throwError(() => err);
      }
      if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 403)) {
        const msg = String(err.error?.message ?? '').toLowerCase();
        const contaBloqueada = err.status === 403 && (msg.includes('bloqueada') || msg.includes('desativad'));
        if (err.status === 401 || contaBloqueada) {
          if (auth.getToken()) {
            auth.clearSession();
            void router.navigate(['/auth/signin']);
          }
        }
      }
      return throwError(() => err);
    }),
  );
};
